import { Page, PageSource } from 'components/shared/Page/Page';
import { Context } from '@alltrails/shared/types/context';
import * as styles from './styles/styles.module.scss';
import useWindowWidth from '../../hooks/useWindowWidth';
import SectionSwitch from '../../components/SectionSwitch';
import HomeHeader from '../../components/blocks/HomeHeader';
import SearchInsightsProvider from '../../components/SearchInsightsProvider';

export type Greetings = { daily_start_time: string; daily_end_time: string; custom_title: string[] }[];

type Props = {
  context: Context;
  heroData: {
    greetingIndex: number;
    images: {
      alt: string;
      w2800Jpg: string;
    }[];
  };
  json: {
    greetings: Greetings;
    sections: { section_type: string }[];
  };
  lists: {
    listItems?: unknown[];
    lists?: unknown[];
  };
  locationData: {
    city: {
      names: { [key: string]: string };
    };
    country: string;
    latLng: (string | number)[];
  };
};

const HomePage = ({ context, locationData, heroData, json, lists }: Props) => {
  const windowWidth = useWindowWidth({});

  return (
    <Page pageSource={PageSource.Home} context={context}>
      <SearchInsightsProvider context={context} pageName={PageSource.Home}>
        <main className={styles.container}>
          <HomeHeader windowWidth={windowWidth} latLng={locationData.latLng} greetings={json.greetings} heroData={heroData} />
          <SectionSwitch initialSections={json.sections} context={context} windowWidth={windowWidth} lists={lists} locationData={locationData} />
        </main>
      </SearchInsightsProvider>
    </Page>
  );
};

export default HomePage;
